import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import _ = require('lodash');
import { Subject } from 'rxjs';
import { RiskEvaluationService } from '../../../services/risk-evaluation.service';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-risk-question-master-board-eval',
  templateUrl: './risk-question-master-board-eval.component.html',
  styleUrls: ['./risk-question-master-board-eval.component.css']
})
export class RiskQuestionMasterBoardEvalComponent implements OnInit {

  questionForm: FormGroup;
  editquestionForm: FormGroup;
  questionMasterList: any[];
  department: any[];
  evaluationTypeList: any[];
  evaluationCriteriaList: any[];
  evaluationType: any;
  evaluationCriteria: any;
  questionID: any;
  questionIdToDelete: any;
  editCriteriaId: any;
  evaluationevalCriteriaList: any[];
  disableSavebutton: boolean = false;
  disableupdatebutton: boolean = false;

  @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private alert: AlertComponent,
    private riskEvaluationService: RiskEvaluationService
  ) { }

  ngOnInit() {
    this.dtOptions = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      // scrollY: "440px",
      // scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      language: {
        //made changes for datatables for next previous button
        paginate: {
          first: '<<',
          last: '>>',
          next: '>',
          previous: '<',
        },
      },
    };

    this.questionForm = new FormGroup({
      // evaluationType: new FormControl('', [Validators.required]),
      evaluationCriteria: new FormControl('', [Validators.required]),
      riskDepartment: new FormControl('', [Validators.required]),
      questionText: new FormControl('', [Validators.required]),
    });

    this.editquestionForm = new FormGroup({
      // editEvaluationType: new FormControl('', [Validators.required]),
      editEvaluationCriteria: new FormControl('', [Validators.required]),
      editRiskDepartment: new FormControl('', [Validators.required]),
      editQuestionText: new FormControl('', [Validators.required]),
    });

    this.getQuestionMasterList();
    this.getEntityListDetails();
    this.getEvaluationCriteriaList();
    this.getDepartmentMasterList();
  }

  getInputValueChange(event: Event): string {
    // @ts-ignore
    return (event.target ? (event.target as HTMLInputElement) : event).value;
  }

  getQuestionMasterList() {
    this.riskEvaluationService
      .getQuestionMasterBoardEvalList()
      .then((response) => {
        if (response.status == 0) {
          $('#questionMasterTable').DataTable().destroy();
          if (_.size(response.questionList)) {
            this.questionMasterList = response.questionList;
            this.dtTrigger.next();
          } else {
            this.questionMasterList = [];
            this.dtTrigger.next();
          }
        } else {
          this.questionMasterList = [];
          this.dtTrigger.next();
        }
      });
  }

  UpdateDesc(event: any) {
    this.department.forEach(item => {
      if (item._id === event.target.value) {
        this.questionForm.get('evaluationCriteria').setValue(item.EvaluationCriteriaID._id);
      }
    });
  }

  UpdateEditedDesc(event: any) {
    this.department.forEach(item => {
      if (item._id === event.target.value) {
        this.editquestionForm.get('editEvaluationCriteria').setValue(item.EvaluationCriteriaID._id);
      }
    });
  }

  getDepartmentMasterList() {
    this.riskEvaluationService
      .getRiskDepartmentList()
      .then((response) => {
        if (response.status == 0) {
          $('#questionMasterTable').DataTable().destroy();
          if (_.size(response.departmentList)) {
            this.department = response.departmentList;
            this.dtTrigger.next();
          } else {
            this.department = [];
            this.dtTrigger.next();
          }
        } else {
          this.department = [];
          this.dtTrigger.next();
        }
      });
  }

  getEntityListDetails() {


    this.riskEvaluationService.getEvaluationTypeList().then((response) => {
      if (response.status == 0) {
        if (_.size(response.evalTypeList)) {
          this.evaluationTypeList = response.evalTypeList;
        } else {
          this.evaluationTypeList = [];
        }
      } else {
        this.evaluationTypeList = [];
      }
    });
  }

  showGetEntityListDetails() {
    //on click of button to show popup form..
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#questionMasterModal').removeClass('show').hide();

    setTimeout(() => {
      $('#questionMasterModal').modal('show');
    }, 100);

    this.riskEvaluationService.getEvaluationTypeList().then((response) => {
      if (response.status == 0) {
        if (_.size(response.evalTypeList)) {
          this.evaluationTypeList = response.evalTypeList;
        } else {
          this.evaluationTypeList = [];
        }
      } else {
        this.evaluationTypeList = [];
      }
    });
  }

  getEvaluationCriteriaList() {
    this.riskEvaluationService.getEvaluationCriteriaList().then((response) => {
      if (response.status == 0) {
        //console.log("criterialist new",response)
        if (_.size(response.evalCriteriaList)) {
          this.evaluationevalCriteriaList = response.evalCriteriaList;
        } else {
          this.evaluationevalCriteriaList = [];
        }
      } else {
        this.evaluationevalCriteriaList = [];
      }
    });
  }

  // getCriteriaListByEntityId(event) {
  //
  //   this.questionForm.controls.evaluationCriteria.setValue("");
  //   this.questionForm.controls.evaluationCriteria.updateValueAndValidity();
  //   var evaluationTypeId = event.target.value;
  //  //console.log("this.questionForm.controls.evaluationCriteria.",this.questionForm.controls.evaluationType.value)

  //   //console.log("event", event.target.value)
  //   this.riskEvaluationService.getEvaluationCriteriaByEvalIdList(evaluationTypeId).then(response => {
  //     if (response.status == 0) {
  //       if (_.size(response.evalCriteriaList)) {
  //         this.evaluationCriteriaList = response.evalCriteriaList;
  //       } else {
  //         this.evaluationCriteriaList = [];
  //       }
  //     } else {
  //       this.evaluationCriteriaList = [];
  //     }
  //   });
  // }

  // getCriteriaListByEntityIdForEditForm(event) {
  //
  //   this.editquestionForm.controls.editEvaluationCriteria.setValue("");
  //   this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
  //   var evaluationTypeId = event.target.value;
  //  //console.log("this.questionForm.controls.evaluationCriteria.",this.editquestionForm.controls.editEvaluationCriteria.value)

  //   //console.log("event", event.target.value)
  //   this.riskEvaluationService.getEvaluationCriteriaByEvalIdList(evaluationTypeId).then(response => {
  //     if (response.status == 0) {
  //       if (_.size(response.evalCriteriaList)) {
  //         this.evaluationCriteriaList = response.evalCriteriaList;
  //       } else {
  //         this.evaluationCriteriaList = [];
  //       }
  //     } else {
  //       this.evaluationCriteriaList = [];
  //     }
  //   });
  // }

  closeForm() {
    this.ngOnInit();
  }

  submitQuestionDetails() {
    this.disableSavebutton = true;
    try {
      const self = this;

      var questionObject = {
        EvaluationCriteriaID: this.questionForm.controls.evaluationCriteria.value,
        RiskDepartmentID: this.questionForm.controls.riskDepartment.value,
        QuestionText: this.questionForm.controls.questionText.value.trim(),
      };

      this.riskEvaluationService.addQuestionDetails(questionObject).then((response) => {
        this.disableSavebutton = false;


        if (response.status == 0) {

          $('#questionMasterModal').modal('hide');
          this.alert.successWithOk1(response.message, () => {
            ////inside popup form dialog
            $('#questionMasterModal').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');


          });
          this.messagePopUpTimeoutToogle();
          this.questionForm.reset();
          this.getQuestionMasterList();
        } else {

          $('#questionMasterModal').modal('hide');
          this.alert.error1(response.message, () => {
            ////inside popup form dialog
            $('#questionMasterModal').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');

          });
           this.messagePopUpTimeoutToogle();
          this.questionForm.reset();
          this.getQuestionMasterList();
        }
        //this.removeBackdrop(); // Manually remove any remaining backdrops
      }
      );
    } catch (error) { }
  }

  removeBackdrop() {
    // Manually remove any remaining modal backdrop
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }
  editQuestionDetails(selectedQuestionID) {
    console.log("Question ID:", selectedQuestionID);
    if (selectedQuestionID != '') {
      //console.log("selectedQuestionID",selectedQuestionID)
      this.questionID = selectedQuestionID;
      // this.riskEvaluationService.getQuestionByQuestionID(this.questionID).then(response => {
      this.editquestionForm.get('editRiskDepartment').setValue(selectedQuestionID['RiskDepartmentID']?._id)
      // if (response.status == 0) {
      this.editquestionForm.controls.editQuestionText.setValue(
        selectedQuestionID.QuestionText
      );

      // this.editquestionForm.controls.editEvaluationType.setValue(selectedQuestionID.EvaluationTypeID._id);
      // this.editquestionForm.controls.editEvaluationType.updateValueAndValidity();

      //console.log("hello edit function")
      // this.evaluationCriteriaList = response.evalCriteriaList;
      this.editCriteriaId = selectedQuestionID.EvaluationCriteriaID._id;
      this.editquestionForm.controls.editEvaluationCriteria.setValue(
        selectedQuestionID.EvaluationCriteriaID._id
      );
      this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
      // this.riskEvaluationService.getEvaluationCriteriaByEvalIdList(selectedQuestionID.EvaluationCriteriaID._id).then(response => {
      //   if (response.status == 0) {
      //     if (_.size(response.evalCriteriaList)) {
      //       //console.log("criteria")
      //       this.evaluationCriteriaList = response.evalCriteriaList;
      //       this.editCriteriaId = selectedQuestionID.EvaluationCriteriaID._id;
      //       this.editquestionForm.controls.editEvaluationCriteria.setValue(selectedQuestionID.EvaluationCriteriaID._id);
      //       this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //     } else {
      //       this.evaluationCriteriaList = [];
      //       this.editCriteriaId = selectedQuestionID.EvaluationCriteriaID._id;
      //       this.editquestionForm.controls.editEvaluationCriteria.setValue(selectedQuestionID.EvaluationCriteriaID._id);
      //       this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //     }
      //   } else {
      //     this.evaluationCriteriaList = [];
      //     this.editCriteriaId = selectedQuestionID.EvaluationCriteriaID._id;
      //     this.editquestionForm.controls.editEvaluationCriteria.setValue(selectedQuestionID.EvaluationCriteriaID._id);
      //     this.editquestionForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //   }
      // });
      // this.editquestionForm.controls.questionText.disable();
      // this.editquestionForm.controls.editEvaluationType.disable();
      // this.editquestionForm.controls.editEvaluationCriteria.setValue(selectedQuestionID.EvaluationCriteriaID);

      $('#editingQuestionModal').modal('toggle');
    } else {
      $('#alertPopUpTitle').css('color', '#f00');
      $('#alertPopUpTitle').text('Failure!');
      $('#alertMessage').text('QUestion Selection Failure');
      $('#alertMessage').css('color', '#f00');
      $('#messagePopUp').modal('toggle');
      this.messagePopUpTimeoutToogle();
    }
    //   });
    // } else {
    //   $('#alertPopUpTitle').css('color', '#f00');
    //   $('#alertPopUpTitle').text("Failure!");
    //   $('#alertMessage').text("Please select valid question.");
    //   $('#alertMessage').css('color', '#f00');
    //   $('#messagePopUp').modal('toggle');
    //   this.messagePopUpTimeoutToogle();
    //   this.questionForm.reset();
    // }
  }

  udpateQuestionDetails() {
    this.disableupdatebutton = true;
    const self = this;

    var questionObject = {
      evaluationQuestionID: this.questionID._id,
      // EvaluationTypeID: this.editquestionForm.controls.editEvaluationType.value,
      RiskDepartmentID: this.editquestionForm.controls.editRiskDepartment.value,
      EvaluationCriteriaID:
        this.editquestionForm.controls.editEvaluationCriteria.value,
      questionText:
        this.editquestionForm.controls.editQuestionText.value.trim(),
    };
    //console.log("questionObject",questionObject);

    this.riskEvaluationService
      .updateEvaluationQuestionDetails(questionObject)
      .then((response) => {
        this.disableupdatebutton = false;
        if (response.status == 0) {
          $('#questionMasterTable').DataTable().destroy();
          $('#editingQuestionModal').modal('toggle');
          $('#alertPopUpTitle').text('Success!');
          $('#alertPopUpTitle').css('color', 'black');
          $('#alertMessage').text('Question updated successfully.');
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();
          this.editquestionForm.reset();
        } else {
          $('#questionMasterTable').DataTable().destroy();
          $('#editingQuestionModal').modal('toggle');
          $('#alertPopUpTitle').text('Failure!');
          $('#alertPopUpTitle').css('color', '#f00');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', '#f00');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();
          this.editquestionForm.reset();
        }
      });
  }

  editquestionTextChange(event) {
    if (event.target.value.trim() == '') {
      this.editquestionForm.controls.editQuestionText.setValue(
        event.target.value.trim()
      );
      this.editquestionForm.controls.editQuestionText.updateValueAndValidity();
    }
  }

  questionFormquestionTextChange(event) {
    if (event.target.value.trim() == '') {
      //console.log("event.target.value",event.target)
      this.questionForm.controls.questionText.setValue(
        event.target.value.trim()
      );
      this.questionForm.controls.questionText.updateValueAndValidity();
    }
  }

  deleteQuestionIdToPass(question) {
    this.questionIdToDelete = question._id;
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#deleteQuestionMasterModal').removeClass('show').hide();

    setTimeout(() => {
      $('#deleteQuestionMasterModal').modal('show');
    }, 100);
  }

  deleteQuestionDetails() {
    //console.log(" this.questionIdToDelete", this.questionIdToDelete);
    this.riskEvaluationService.deleteQuestionDetails(this.questionIdToDelete)
      .then((response) => {
        // Hide the modal and remove any remaining backdrops
        $('#deleteQuestionMasterModal').modal('toggle');
        this.removeBackdrop(); // Manually remove any leftover backdrops

        // Set alert details based on response status
        const isSuccess = response.status == 0;
        const alertColor = isSuccess ? 'black' : '#f00';
        const alertTitle = isSuccess ? 'Success!' : 'Failure!';

        // $('#alertPopUpTitle').text(alertTitle).css('color', alertColor);
        // $('#alertMessage').text(response.message).css('color', alertColor);
        // ////inside popup form dialog
        // $('#deleteQuestionMasterModal').off('hidden.bs.modal');
        // $('.modal-backdrop').remove();
        // $('body').removeClass('modal-open');
        // $('#deleteQuestionMasterModal').modal('hide');
        // this.messagePopUpTimeoutToogle();

        if (response.status == 0) {
          $('#questionMasterTable').DataTable().destroy();
          $('#alertPopUpTitle').text('Success!');
          $('#alertPopUpTitle').css('color', 'black');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();
        } else {
          $('#questionMasterTable').DataTable().destroy();
          $('#alertPopUpTitle').text('Failure!');
          $('#alertPopUpTitle').css('color', '#f00');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', '#f00');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();

        }

        // Refresh question list
        this.getQuestionMasterList();
        this.getEntityListDetails();
      });
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  editCriteria(event) {
    //console.log("event", event.target.value)
  }
}

